import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

const normalizePermissionValues = (responseData) => {
    const normalizeKey = (value) =>
        typeof value === "string" ? value.trim().toLowerCase() : null;
    const mapArrayItems = (items) =>
        items
            .map((item) => {
                if (typeof item === "string") return normalizeKey(item);
                if (typeof item?.name === "string") return normalizeKey(item.name);
                if (typeof item?.permission === "string") return normalizeKey(item.permission);
                if (typeof item?.key === "string") return normalizeKey(item.key);
                return null;
            })
            .filter(Boolean);

    const directArray =
        responseData?.permissionKeys ||
        responseData?.PermissionKeys ||
        responseData?.permissions ||
        responseData;

    if (Array.isArray(directArray)) {
        return mapArrayItems(directArray);
    }

    if (responseData && typeof responseData === "object") {
        if (Array.isArray(responseData.permissions)) {
            return mapArrayItems(responseData.permissions);
        }
        if (Array.isArray(responseData.permissionKeys)) {
            return mapArrayItems(responseData.permissionKeys);
        }
        if (Array.isArray(responseData.PermissionKeys)) {
            return mapArrayItems(responseData.PermissionKeys);
        }

        const trueKeys = Object.keys(responseData).filter(
            (key) => responseData[key] === true,
        );
        if (trueKeys.length > 0) {
            return trueKeys.map((key) => normalizeKey(key)).filter(Boolean);
        }
    }

    return [];
};

export const getMyPermissions = () => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.get(`${FIRMFLOWURL}api/me/permissions`, {
                headers: { Authorization: token },
            });

            resolve({
                ...response,
                success: true,
                permissionKeys: normalizePermissionValues(response.data),
            });
        } catch (err) {
            const status = err.response?.status;
            if (status === 401 || err.message.includes("401")) {
                Cookies.remove("Bearer");
                resolve({ success: false, status: 401, permissionKeys: [] });
                return;
            }

            resolve({
                success: false,
                status,
                message: err.response?.data?.message || err.message,
                permissionKeys: [],
            });
        }
    });
};
